import DragAndDropLoadMedia, {
  ACCEPTED_IMAGE_TYPES,
} from "./DragAndDropLoadMedia";
import { FormFieldProps } from "./types";

export { ACCEPTED_IMAGE_TYPES };

/**
 * Image-only drag-and-drop field. Thin wrapper over the generalized
 * {@link DragAndDropLoadMedia} with the video option disabled, kept for
 * backwards compatibility with existing call sites (artmatch, etc.).
 */
const DragAndDropLoadImage = (props: FormFieldProps) => {
  return <DragAndDropLoadMedia {...props} allowVideo={false} />;
};

export default DragAndDropLoadImage;
